import React from "react";
import { connect } from "react-redux";
import { Input, Select } from "../Input";
import { Button } from "../Button";
import language from "../../language";
import axios from "axios";
import toastMessage from "../../utils/toastMessage";
import { menus } from "../../constants/accessRolesList";
import availableOptions from "../../constants/availableOptions";
import { getStorage } from "../../utils/storage";
import Permissions from "./Permissions";
import icons from "../../constants/icons";
import apiError from "../../utils/apiError";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

class NewAccessRole extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      error: {},
      isSubmitting: false,
      operations: {},
      menus: menus(props.defaultLanguage),
      available: availableOptions[0],
      centers: [],
      centerSites: [],
      defaultPage: "",
      selectedMenus: null,
    };
  }

  componentDidMount() {
    if (this.props._id) {
      const { menus } = this.state;

      // Built fresh rather than pushed into state. selectedMenus starts as
      // null, and a destructuring default only fires on undefined - so the
      // "= []" was skipped and .push threw on null, taking the whole
      // control panel down with a white screen whenever a role was opened.
      const selectedMenus = (menus || []).filter((menu) =>
        this.props?.permissions?.menus?.includes(menu.value),
      );

      const operations = this.props?.permissions?.operations || {};

      this.setState({
        _id: this.props._id,
        name: this.props.name,
        available:
          availableOptions.find(
            (el) => el.value === this.props.available + ""
          ) || availableOptions[0],
        selectedMenus,
        defaultPage: this.props.defaultPage,
        operations,
      });
    }
  }

  onChangeText(field, e) {
    const inputValue = e?.target ? e?.target?.value : e;
    let { error } = this.state;
    delete error[field];

    this.setState({
      [field]: inputValue,
      error,
    });
  }

  handleCheckOperations(menu, operation) {
    let { operations } = this.state;

    if (!operations[operation]) {
      operations[operation] = [];
    }

    if (operations[operation].includes(menu)) {
      operations[operation].splice(operations[operation].indexOf(menu), 1);
    } else {
      operations[operation].push(menu);
    }

    this.setState({ operations });
  }

  validateForm() {
    let { name, error, selectedMenus } = this.state;

    if (name === "") {
      error.name =
        language[this.props.defaultLanguage].access_role_name_required;
    }

    if (!selectedMenus) {
      error.selectedMenus =
        language[this.props.defaultLanguage].access_role_menus_required;
    }

    this.setState({ error });
  }

  onSubmit = async () => {
    await this.validateForm();

    const { add_access_role_success, update_access_role_success } =
      language[this.props.defaultLanguage];

    const { selectedMenus, operations, name, _id, available, defaultPage } =
      this.state;
    const user = await getStorage();

    if (Object.keys(this.state.error).length === 0) {
      this.setState({
        isSubmitting: true,
      });

      let menus = selectedMenus.map((el) => {
        return el.value;
      });

      let operationPaths = {};

      selectedMenus.forEach((el) => {
        Object.keys(el.paths).forEach((key) => {
          if (!el.paths[key]) {
            el.paths[key] = [];
          }

          el.paths[key].forEach((path) => {
            if (!operationPaths[key]) {
              operationPaths[key] = [];
            }
            if (!operationPaths[key].includes(path)) {
              operationPaths[key].push(path);
            }
          });
        });
      });

      let requestBody = {
        name: name.toUpperCase(),
        permissions: {
          menus,
          operations,
          operationPaths,
        },
        institution: user.institution,
        available: available.value,
        defaultPage,
      };

      let url = `${API_URL}/accessRole`,
        method = "POST";

      if (_id && _id !== "") {
        method = "PUT";
        requestBody.id = _id;
      }

      const options = {
        method,
        url,
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + user.token,
        },
        data: requestBody,
      };

      axios(options)
        .then((data) => {
          this.setState({
            isSubmitting: false,
          });

          toastMessage(
            "success",
            method === "PUT"
              ? update_access_role_success
              : add_access_role_success
          );

          this.props.getData(true);
          this.props.handleCloseModal();
        })
        .catch((error) => {
          const {
            error_update_access_role,
            error_add_access_role,
            access_role_exist,
          } = language[this.props.defaultLanguage];

          this.setState({
            isSubmitting: false,
          });

          apiError(error, {
            requestMethod: method,
            addErrorMessage: error_add_access_role,
            updateErrorMessage: error_update_access_role,
            dataExistErrorMessage: access_role_exist,
          });
        });
    }
  };

  render() {
    return (
      <div>
        <div className="card-body">
          <Input
            placeholder={
              language[this.props.defaultLanguage].access_role_name_placeholder
            }
            label={language[this.props.defaultLanguage].access_role}
            required
            value={this.state.name}
            onChange={(e) => this.onChangeText("name", e)}
            error={this.state.error.name}
          />
          <Input
            placeholder={language[this.props.defaultLanguage].page}
            label={language[this.props.defaultLanguage].default_page}
            value={this.state.defaultPage}
            onChange={(e) => this.onChangeText("defaultPage", e)}
            error={this.state.error.defaultPage}
          />
          <Select
            leftIcon={icons.menu}
            options={this.state.menus}
            placeholder={language[this.props.defaultLanguage].select}
            label={language[this.props.defaultLanguage].menus}
            required
            value={this.state.selectedMenus}
            onChange={(e) => this.onChangeText("selectedMenus", e)}
            error={this.state.error.selectedMenus}
            isMulti
            isCreatable
          />
          <div
            className="row"
            style={{ backgroundColor: "#f9f9f9", padding: "1rem 0" }}
          >
            {this.state?.selectedMenus?.map((menu, m) => {
              let operations = menu.operations;

              if (!menu.operations || menu?.operations?.length === 0) {
                operations = [
                  { label: "Create", value: "create", action: "_POST" },
                  { label: "Read", value: "read", action: "_GET" },
                  { label: "Update", value: "update", action: "_PUT" },
                  {
                    label: "Delete",
                    value: "delete",
                    action: "_DELETE",
                  },
                ];
              }
              return (
                <>
                  <div className="col-md-12" key={m}>
                    <div className="card" style={{ marginBottom: "1rem" }}>
                      <Permissions
                        title={menu.label}
                        key={m}
                        operationMenus={this.state.operations}
                        operations={operations}
                        menuItem={menu.value}
                        handleCheckOperations={this.handleCheckOperations.bind(
                          this
                        )}
                      />
                    </div>
                  </div>
                  {m % 2 === 0 && (
                    <div className="clearfix visible-xs visible-sm"></div>
                  )}
                </>
              );
            })}
          </div>
        </div>
        <div className="modal-footer">
          <Button
            text={language[this.props.defaultLanguage].cancel}
            onPress={this.props.handleCloseModal}
            className="btn-default"
          />
          <Button
            text={language[this.props.defaultLanguage].submit}
            onPress={this.onSubmit.bind(this)}
            isSubmitting={this.state.isSubmitting}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(NewAccessRole);
